import { render, staticRenderFns } from "./alertSubscribe.vue?vue&type=template&id=bf4088a6&scoped=true&"
import script from "./alertSubscribe.vue?vue&type=script&lang=js&"
export * from "./alertSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./alertSubscribe.vue?vue&type=style&index=0&id=bf4088a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4088a6",
  null
  
)

export default component.exports